import getWeb3 from './getWeb3'
import ipfs from 'ipfs-mini';
import contract from "truffle-contract"
import TheWallContract from '../contracts/TheWall.json'
import { Buffer } from 'buffer';
import bs58 from 'bs58';
import { refreshPosts, listenToEvents } from './wallActions'

export function initWeb3(payload) {
    return function(dispatch) {
        dispatch({type: "INIT_WEB3_PENDING"});
        
        getWeb3
        .then(results => {
            let ipfsInit = new ipfs();

            ipfsInit.setProvider({ host: 'ipfs.infura.io', port: 5001, protocol: 'https' });
            //ipfsInit.setProvider({ host: '127.0.0.1', port: 5001, protocol: 'http' });
            //ipfsInit.setProvider({ host: 'gateway.ipfs.io', port: 5001, protocol: 'https' });
            //ipfsInit.setProvider({ host: 'ipfs.io', port: 5001, protocol: 'https' });
            //ipfsInit.setProvider({ host: 'upload.global', port: 5001, protocol: 'https' });
            //ipfsInit.setProvider({ host: 'ipfs.works', port: 5001, protocol: 'https' });
            //ipfsInit.setProvider({ host: 'api.wisdom.sh', port: 5001, protocol: 'https' });

            let theWallContract = contract(TheWallContract)
            theWallContract.setProvider(results.web3.currentProvider)

            let theWallInstance = null;
            results.web3.eth.getAccounts((error, accounts) => {

                theWallContract.deployed().then((instance) => {
                    theWallInstance = instance
                    
                    dispatch({type: "INIT_WEB3_SUCCESS", payload: {
                        web3Instance: results.web3,
                        ipfsInstance : ipfsInit,
                        theWallContract : theWallContract,
                        theWallInstance : theWallInstance,
                        ethAccount: accounts[0]
                    }})
                        
                    dispatch(listenToEvents(payload));

                    dispatch(refreshPosts(payload));

                }).catch((err) => {
                    dispatch({type: "INIT_WEB3_ERROR", payload: err})
                })
              })
            
        })
        .catch((err) => {
            dispatch({type: "INIT_WEB3_ERROR", payload: err})
        })
      }    
}

export function ipfsDecode (hash) {

    if (hash && hash.length > 2 && hash.slice(0,2) === "Qm") {
        hash = hash.slice(2);
        var bytes = bs58.decode(hash);
        var hex = bytes.toString('hex');
        if(hex.length > 2) {
            return "0x" + hex.slice(2);
        }
    }
    return "";
}

export function ipfsEncode (hex) {
    if (Buffer.isBuffer(hex)) hex = hex.toString("hex");
    if (hex && hex.constructor === String) {
        hex = hex.replace("0x", "");
        if (hex.length !== 64) {
            throw new Error("length error: expected 32-byte input");
        }
        if (parseInt(hex.slice(0, 2), 16) > 60) {
            hex = "01" + hex;
        } else {
            hex = "02" + hex;
        }
        return "Qm" + bs58.encode(new Buffer(hex, "hex"));
    }
    throw new Error("unsupported format: expected hex string");
}



// WEBPACK FOOTER //
// ./src/actions/web3Actions.js